
angular.module('bmsApp.directives')
	.directive('timePicker', function ($timeout) {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				ngModel: '=',
				timePicker: '=',
				events: '=?'
			},
			link: function (scope, element, attrs, ngModel) {

				var config;
				var instance;
				
				if (angular.isUndefined(scope.timePicker.options)) {
					throw new Error("TimePicker expects an 'options' object");
				}

				config = scope.timePicker.options;
				
				//$timeout(function () {
					instance = element.timeEntry(config);

					if (!angular.isUndefined(scope.events)) {
						angular.forEach(scope.events, function (handler, event) {
							instance.on(event, handler);
						});
					}

					// bind the given event handlers
					angular.forEach(scope.timePicker.eventHandlers, function (handler, event) {
						instance.on(event, handler);
					});

				//}, 0);

				scope.$watch(function () {
					return ngModel.$modelValue;
				}, function (newValue, oldValue) {
					if (!angular.isUndefined(instance) && !angular.isUndefined(newValue)) {
						element.timeEntry('setTime', newValue);
					}
				});

			},
		};
	});
